import { render } from "./TrustProfileOverviewDashboard.vue?vue&type=template&id=046dbf7b"
import script from "./TrustProfileOverviewDashboard.vue?vue&type=script&lang=js"
export * from "./TrustProfileOverviewDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__